export const calculateResult = (answer) => {
  const result = [
    answer[0] + answer[1] + answer[2] > 0 ? "e" : "i",
    answer[3] + answer[4] + answer[5] > 0 ? "s" : "n",
    answer[6] + answer[7] + answer[8] > 0 ? "t" : "f",
    answer[9] + answer[10] + answer[11] > 0 ? "j" : "p",
  ]

  return result[0] + result[1] + result[2] + result[3]
}

/*
 <1 or -1>
  E or I
  S or N
  T or F
  J or P
*/
